import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformApplicationErrorCode {
  ApplicationRuntimeError = 'ApplicationRuntimeError',
}

class EditorPlatformApplicationError extends BaseError<EditorPlatformApplicationErrorCode> {
  state: Partial<{
    url: string;
    appDefinitionId: string;
    apiMethod: string;
    apiType: string;
  }> = {};

  constructor(message: string, code: EditorPlatformApplicationErrorCode) {
    super(message, code, 'EP Application Error');
  }

  withUrl(url: string) {
    this.state = { ...this.state, url };
    return this;
  }

  withAppDefinitionId(appDefinitionId: string) {
    this.state = { ...this.state, appDefinitionId };
    return this;
  }

  withApiMethod(apiMethod: string) {
    this.state = { ...this.state, apiMethod };
    return this;
  }

  withApiType(apiType: string) {
    this.state = { ...this.state, apiType };
    return this;
  }
}

export const createEditorPlatformApplicationError = createErrorBuilder<
  EditorPlatformApplicationErrorCode,
  EditorPlatformApplicationError
>(EditorPlatformApplicationError);
